module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_7005.cfdcf5b8.png";